import React from 'react';
import { categoryIconSrc } from './categoryIconSrc';

/**
 * A category's icon on a light tile. Icons are drawn in #212121 for the apps'
 * light tiles, so on the back-office's dark theme they need one of their own.
 */
export function CategoryIcon({ category, src, size = 20 }) {
    const iconSrc = src !== undefined ? src : categoryIconSrc(category);
    return (
        <span style={{
            display: 'inline-grid',
            placeItems: 'center',
            width: size + 8,
            height: size + 8,
            flex: 'none',
            background: '#fcfdfd',
            borderRadius: 6,
            verticalAlign: 'middle',
        }}>
            {iconSrc && <img src={iconSrc} alt="" style={{ width: size, height: size }} />}
        </span>
    );
}
